export * from './details-modal'
